import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.INTEGRATIONS,
    path: 'integration',
    component: () => import('./pages/IntegrationsIndex.vue'),
    meta: {
      settingsMode: true,
      title: 'Integration',
      description:
        'Connect your email marketing platform or CRM to sync visitor data and enable two-way communication.'
    }
  },
  {
    name: ROUTES.INTEGRATION,
    path: 'integration/:integration',
    component: () => import('./pages/IntegrationShow.vue'),
    meta: {
      settingsMode: true,
      title: 'Integration'
    }
  }
]
